import * as React from 'react';
import { FC, useState } from 'react';
import useInputErrorsDebouncer from 'app/useInputErrorsDebouncer';
import type { Locales, Values, ChangeValues, Errors } from './types';
import { PASSWORD_INPUT_PATTERN } from './usePasswordValidation';

const Password: FC<{
  values: Values;
  changeValues: ChangeValues;
  errors: Errors;
  locales: Locales;
}> = ({ values, changeValues, errors, locales }) => {
  const [visible, setVisible] = useState(false);
  const { password } = values;
  const passwordErrors = errors.password || [];
  const [canShowErrors, delayErrors] = useInputErrorsDebouncer();
  const showErrors = password && canShowErrors;

  return (
    <div className={`input player_password ${showErrors && passwordErrors.length ? 'error' : ''}`}>
      <div className="input-with-icon">
        <input
          autoComplete="new-password"
          placeholder={locales.password.placeholder}
          type={visible ? 'text' : 'password'}
          name="player[password]"
          id="player_password"
          value={password}
          onChange={(e) => {
            const pass = e.target.value;
            if (PASSWORD_INPUT_PATTERN.test(pass)) {
              changeValues({ password: pass });
              delayErrors();
            }
          }}
        />
        <span className="icon" />
        {password && (
          <i
            onClick={() => setVisible((v) => !v)}
            className={`visibility rs-icon-${visible ? 'eye' : 'eye-slash'}`}
            title={visible ? 'hide' : 'show'}
          />
        )}
      </div>
      {[locales.password.hint, locales.password.must_not_eq_login].map((error) => (
        <small key={error} className={showErrors && passwordErrors.includes(error) ? 'error' : 'hint'}>
          {error}
        </small>
      ))}
    </div>
  );
};

export default Password;
